import Api from "@/api/index";
import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/components/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";

const classes = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    detail: {},
    queryParam: {},
    modalCreate: false,
    modalEdit: false,
    loading: false,
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_DETAIL(state, datas) {
      state.detail = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_MODAL_EDIT(state, data) {
      state.modalEdit = data;
    },
  },
  actions: {
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("classes").then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },
    async getKelasByProgram({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet(`classes?program_id=${payload}`).then(
        ({ data }) => {
          commit("SET_ALL", data);
          commit("SET_LOADING", false);
        }
      );
    },
    async show({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet(`classes/${payload}`).then(({ data }) => {
        commit("SET_DETAIL", data);
        commit("SET_MODAL_EDIT", true);
        commit("SET_LOADING", false);
      });
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("classes/page", payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    onRefresh({ state }) {
      store.dispatch("classes/paginate", state.queryParam);
    },
    onAction({ commit }, payload) {
      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Update") {
        store.dispatch("classes/show", payload[0].kelas_id);
        store.dispatch("students/getStudentByKelasId", payload[0].kelas_id);
      }
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `classes/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.post("classes", payload)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("classes/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async update({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.put(
        "classes/" + payload.kelas_id,
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_EDIT", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("classes/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default classes;
